<div class="flex flex-row mt-3 mb-3">
    <div class="w-6 mr-6">
        <h4>Review and Confirm</h4>
        <h5 class="mb-4">Product Details</h5>
        <div class="flex justify-content-between mb-3">
            <span class="summary-label">Product Name:</span>
            <span>{{productDetails.selectedProduct.Name}}</span>
        </div>
        <div class="flex justify-content-between mb-3">
            <span class="summary-label">Item Identifier:</span>
            <span>{{productDetails.serialNumber ? productDetails.serialNumber : '-'}}</span>
        </div>
        <div class="flex justify-content-between mb-3">
            <span class="summary-label">Payment Type:</span>
            <span>{{productDetails.payment}}</span>
        </div>
        <div class="flex justify-content-between mb-2">
            <span class="summary-label">Product Price:</span>
            <span class="product-price w-6 justify-content-end">
                {{productDetails.selectedProduct.Price | currency: 'PHP' : 'symbol' : '1.2-2'}}
            </span>
        </div>
        <div class="flex justify-content-between mb-2">
            <span class="summary-label">Security Bond:</span>
            <span class="product-price w-6 justify-content-end">
                {{productDetails.selectedProduct.SecurityBondAmount | currency: 'PHP' : 'symbol' : '1.2-2'}}
            </span>
        </div>
    </div>
    <div class="w-6">
        <h5 class="mb-4">Product Image(s)</h5>
        <p-carousel 
            [value]="productDetails.imageUrl" 
            [numVisible]="1" 
            [numScroll]="1" 
            [circular]="false" 
            [responsiveOptions]="responsiveOptions">
                <ng-template let-image pTemplate="item">
                    <div class="border-1 surface-border border-round m-2 p-3">
                        <div class="mb-3">
                            <div class="relative mx-auto text-center">
                                <img 
                                    src="{{image}}" 
                                    class="w-50 border-round" />
                            </div>
                        </div>
                    </div>
                </ng-template>
        </p-carousel>
    </div>
</div>
<hr>
<div class="flex flex-row">
        <div class="w-6 mr-6">
            <h5 class="mb-4">Penalties</h5>
            <div class="flex justify-content-between mb-3">
                <span class="summary-label">Penalty Cut-off:</span>
                <span>
                    {{productDetails.selectedProduct.PenaltyCutOffDays}} Days
                </span>
            </div>
        </div>
        <div class="w-6">
            <div class="flex justify-content-between mb-3 mt-custom">
                <span class="summary-label">Collections Cut-off:</span>
                <span>
                    {{productDetails.selectedProduct.DaysBeforeCollection}} Days
                </span>
            </div>
        </div>
    </div>
<hr>
<div class="flex flex-row">
    <div class="w-6 mr-6">
        <h5 class="mb-4">Payment Terms</h5>
        <div class="flex justify-content-between mb-3">
            <span class="summary-label">Frequency:</span>
            <span>{{paymentTerms.selectedFrequency.name}}</span>
        </div>
        <div class="flex justify-content-between mb-3">
            <span class="summary-label">Payment Period:</span>
            <span>{{paymentTerms.selectedPeriod.name}}</span>
        </div>
        <div class="flex justify-content-between mb-3">
            <span class="summary-label">Driver Consent:</span>
            <span>{{paymentTerms.driverConsent ? 'Yes' : 'No'}}</span>
        </div>
        <div class="flex justify-content-between mb-2">
            <span class="summary-label">Estimated Deduction Amount:</span>
            <span class="product-price w-6 justify-content-end">P83.00</span>
        </div>

        <div class="flex justify-content-between">
            <span class="summary-label">Estimated Number of Payments:</span>
            <span class="product-price w-6 justify-content-end">50</span>
        </div>
    </div>
    <div class="w-6">
        <h5 class="mb-4">Agreement Documents</h5>
        <div class="flex flex-column">
            <div *ngFor="let image of paymentTerms.pdfUrl; let i = index" class="flex flex-row mb-3">
                <img class="cursor-pointer mr-4" (click)="getSafeUrl(image)" src="XpressApp\assets\images\pdf-icon.png" width="80px" alt="file" />
                <span>{{paymentTerms.files[i].name}}</span> 
            </div>
        </div>
    </div>
</div>

<!-- PDF Viewer -->
<p-dialog
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="hideDialog()"
    [style]="{height: '560px'}"
    [(visible)]="isPdfViewable">
    <ng-template pTemplate="body">
        <iframe class="mb-3" [src]="safeUrl" [style]="{ width: '500px', display: 'block', height: '511px'}"></iframe>
    </ng-template>
</p-dialog>